import { FormSwitchField, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { LocalizedTypography } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { ConfigureDeviceAuthFieldNames } from './useConfigureDeviceAuthForm';

export function ConfigureDeviceAuthPanelContent() {
    return (
        <Stack vertical spacing="200">
            <FormSwitchField
                label={<LocalizedText textKey={TextKey.DeviceAuthConfigurationSwitch} />}
                name={ConfigureDeviceAuthFieldNames.Enabled}
            />
            <LocalizedTypography textStyle="bodyMedium" textKey={TextKey.DeviceAuthConfigurationSwitchHelp} as="div" />
        </Stack>
    );
}
